if (!window.Eurus.loadedScript.has('collection-list-product-back-in-stock.js')) {
  window.Eurus.loadedScript.add('collection-list-product-back-in-stock.js');

  const KLAVIYO_REVISION = '2024-10-15';

  function subscribeBackInStock(apiKey, variantId, email) {
    return fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(apiKey)}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email }
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`
              }
            }
          }
        }
      })
    });
  }

  function subscribeNewsletterList(apiKey, listId, email) {
    return fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(apiKey)}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  subscriptions: {
                    email: {
                      marketing: { consent: 'SUBSCRIBED' }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: listId }
            }
          }
        }
      })
    });
  }

  function storageKey(variantId) {
    return `eurus:back-in-stock:${variantId}`;
  }

  let snackbarHideTimeout = null;

  function showBackInStockSnackbar(message) {
    let snackbar = document.querySelector('[data-collection-list-back-in-stock-snackbar]');
    if (!snackbar) {
      snackbar = document.createElement('div');
      snackbar.className = 'collection-list-back-in-stock-snackbar';
      snackbar.setAttribute('data-collection-list-back-in-stock-snackbar', '');
      snackbar.setAttribute('role', 'status');
      snackbar.setAttribute('aria-live', 'polite');
      snackbar.innerHTML = '<span class="collection-list-back-in-stock-snackbar__icon" aria-hidden="true"><svg width="100%" height="100%" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M20.3232 6.71851L9.32324 17.7185L4.32324 12.7185" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="square" stroke-linejoin="round"/></svg></span><span class="collection-list-back-in-stock-snackbar__text"></span>';
      document.body.appendChild(snackbar);
    }

    snackbar.querySelector('.collection-list-back-in-stock-snackbar__text').textContent = message;
    snackbar.classList.add('is-visible');

    clearTimeout(snackbarHideTimeout);
    snackbarHideTimeout = setTimeout(() => {
      snackbar.classList.remove('is-visible');
    }, 5000);
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('xCollectionListProductBackInStock', (variantId, apiKey, listId, snackbarTemplate) => ({
      notifyModalOpen: false,
      email: '',
      savedEmail: '',
      alreadySubscribed: false,
      subscribeNewsletter: false,
      submitting: false,
      submitted: false,
      error: false,
      init() {
        const storedEmail = localStorage.getItem(storageKey(variantId));
        if (!storedEmail) return;

        this.email = storedEmail;
        this.savedEmail = storedEmail;
        this.alreadySubscribed = true;
      },
      closeNotifyModal() {
        this.notifyModalOpen = false;
      },
      async submitBackInStock() {
        if (!this.email || this.submitting) return;

        this.submitting = true;
        this.error = false;

        try {
          const response = await subscribeBackInStock(apiKey, variantId, this.email);
          if (!response.ok) throw new Error(`Back in stock subscription failed: ${response.status}`);

          if (this.subscribeNewsletter && listId) {
            try {
              await subscribeNewsletterList(apiKey, listId, this.email);
            } catch (newsletterError) {

              console.error(newsletterError);
            }
          }

          const isNewEmail = this.email !== this.savedEmail;

          localStorage.setItem(storageKey(variantId), this.email);
          this.savedEmail = this.email;
          this.alreadySubscribed = true;

          if (isNewEmail) {
            this.submitted = true;
          }

          if (snackbarTemplate) {
            showBackInStockSnackbar(snackbarTemplate.replace('__EMAIL__', this.email));
          }

          this.notifyModalOpen = false;
        } catch (submitError) {
          console.error(submitError);
          this.error = true;
        } finally {
          this.submitting = false;
        }
      }
    }));
  });
}
